import React from "react"

import { prepaid } from "@signals"
import { AppPrepaidAutocomplete } from "@components/Autocomplete"


export default function PrepaidSelect({ ...props }) {
    return <AppPrepaidAutocomplete
		value={prepaid.value}
		onChange={e => prepaid.value = e.target.value}
		{...props}
	/>
}